(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diy-crystal-bracelet"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-diy-bracelet]').forEach((builder) => {
    const selected = [];
    const canvas = builder.querySelector('[data-canvas]');
    const empty = builder.querySelector('[data-empty]');
    const count = builder.querySelector('[data-count]');
    const materialTotal = builder.querySelector('[data-material-total]');
    const total = builder.querySelector('[data-total]');
    const validation = builder.querySelector('[data-validation]');
    const add = builder.querySelector('[data-add]');
    const designInput = builder.querySelector('[data-design-input]');
    const sizeInput = builder.querySelector('[data-size-input]');
    const cordInput = builder.querySelector('[data-cord-input]');
    const estimateInput = builder.querySelector('[data-estimate-input]');
    const basePrice = Number(builder.dataset.basePrice || 20);
    const showMaterialEstimates = builder.dataset.showMaterialEstimates === 'true';
    let minimum = 12;
    let wristSize = builder.querySelector('[data-size].is-selected')?.textContent.trim() || '';
    let cord = builder.querySelector('[data-cord].is-selected')?.dataset.cordName || '';
    const format = (amount) => `$${amount.toFixed(2)}`;

    const render = () => {
      canvas.querySelectorAll('.diy-bracelet__bead').forEach((bead) => bead.remove());
      const radius = 39;
      selected.forEach((material, index) => {
        const angle = ((index / selected.length) * 360 - 90) * (Math.PI / 180);
        const bead = document.createElement('span');
        bead.className = 'diy-bracelet__bead';
        bead.style.setProperty('--bead-color', material.color || '#c6b5d3');
        bead.style.left = `${50 + Math.cos(angle) * radius}%`;
        bead.style.top = `${50 + Math.sin(angle) * radius}%`;
        bead.style.transform = 'translate(-50%, -50%)';
        if (material.image) {
          const image = document.createElement('img');
          image.src = material.image;
          image.alt = material.name;
          bead.append(image);
        }
        canvas.append(bead);
      });
      const extra = selected.reduce((sum, material) => sum + material.price, 0);
      const remaining = Math.max(minimum - selected.length, 0);
      empty.hidden = selected.length > 0;
      count.textContent = selected.length;
      if (showMaterialEstimates) materialTotal.textContent = format(extra);
      total.textContent = format(showMaterialEstimates ? basePrice + extra : basePrice);
      designInput.value = selected.map((material) => material.name).join(' · ');
      sizeInput.value = wristSize;
      cordInput.value = cord;
      estimateInput.value = format(showMaterialEstimates ? basePrice + extra : basePrice);
      validation.textContent = remaining ? `Add ${remaining} more bead${remaining === 1 ? '' : 's'} to complete your ${wristSize} bracelet.` : 'Your bracelet is ready to add to cart.';
      add.disabled = remaining > 0;
    };

    builder.querySelectorAll('[data-material]').forEach((button) => {
      button.addEventListener('click', () => {
        selected.push({ name: button.dataset.name, price: Number(button.dataset.price || 0), image: button.dataset.image, color: button.dataset.color });
        render();
      });
    });
    builder.querySelectorAll('[data-material-filter]').forEach((filter) => {
      filter.addEventListener('click', () => {
        const category = filter.dataset.materialFilter;
        builder.querySelectorAll('[data-material-filter]').forEach((item) => { item.classList.toggle('is-active', item === filter); item.setAttribute('aria-selected', item === filter ? 'true' : 'false'); });
        builder.querySelectorAll('[data-material]').forEach((item) => { item.hidden = item.dataset.category !== category; });
      });
    });
    builder.querySelectorAll('[data-material]').forEach((item) => { item.hidden = item.dataset.category !== '8mm'; });
    builder.querySelector('[data-remove]').addEventListener('click', () => { selected.pop(); render(); });
    builder.querySelector('[data-clear]').addEventListener('click', () => { selected.length = 0; render(); });
    builder.querySelectorAll('[data-size]').forEach((button) => {
      button.addEventListener('click', () => {
        builder.querySelectorAll('[data-size]').forEach((item) => { item.classList.remove('is-selected'); item.setAttribute('aria-pressed', 'false'); });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        minimum = Number(button.dataset.minimum || 12);
        wristSize = button.textContent.trim();
        render();
      });
    });
    builder.querySelectorAll('[data-cord]').forEach((button) => {
      button.addEventListener('click', () => {
        builder.querySelectorAll('[data-cord]').forEach((item) => { item.classList.remove('is-selected'); item.setAttribute('aria-pressed', 'false'); });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        cord = button.dataset.cordName;
        canvas.classList.toggle('is-elastic', button.dataset.cordType === 'elastic');
        canvas.classList.toggle('is-silver', button.dataset.cordType === 'silver');
        render();
      });
    });
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diy-crystal-pet-collar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-diy-collar]').forEach((builder) => {
    const selected = []; const maximum = 12; const frontCapacity = 8; const canvas = builder.querySelector('[data-canvas]'); const empty = builder.querySelector('[data-empty]'); const count = builder.querySelector('[data-count]'); const validation = builder.querySelector('[data-validation]'); const add = builder.querySelector('[data-add]'); const baseImage = builder.querySelector('[data-base-image]'); const baseSummary = builder.querySelector('[data-base-summary]'); const baseInput = builder.querySelector('[data-base-input]'); const designInput = builder.querySelector('[data-design-input]'); const sizeInput = builder.querySelector('[data-size-input]'); let base = builder.querySelector('[data-collar-base].is-selected');
    const renderBase = () => { if (!base) return; const image = base.dataset.image; canvas.style.setProperty('--collar-color', base.dataset.color || '#3a3436'); baseImage.innerHTML = ''; canvas.classList.toggle('has-base-image', Boolean(image)); if (image) { const element = document.createElement('img'); element.src = image; element.alt = ''; baseImage.append(element); } if (baseSummary) baseSummary.textContent = `${base.dataset.name} · ${base.dataset.size}`; if (baseInput) baseInput.value = base.dataset.name; if (sizeInput) sizeInput.value = base.dataset.size; };
    const positionFor = (index) => {
      const frontCount = Math.min(selected.length, frontCapacity);
      const isFront = index < frontCapacity;
      const groupCount = isFront ? frontCount : selected.length - frontCapacity;
      const groupIndex = isFront ? index : index - frontCapacity;
      const start = isFront ? 150 : 210;
      const end = isFront ? 30 : 330;
      const angle = (start + (groupCount === 1 ? (end - start) / 2 : (end - start) * groupIndex / (groupCount - 1))) * (Math.PI / 180);
      return { left: 50 + Math.cos(angle) * 35, top: 50 + Math.sin(angle) * 24 };
    };
    const render = () => { canvas.querySelectorAll('.diy-collar__bead').forEach((bead) => bead.remove()); selected.forEach((material,index) => { const position = positionFor(index); const bead = document.createElement('span'); bead.className = 'diy-collar__bead'; bead.style.setProperty('--bead-color',material.color || '#c6b5d3'); bead.style.left = `${position.left}%`; bead.style.top = `${position.top}%`; bead.style.transform = 'translate(-50%,-50%)'; if(material.image){const image=document.createElement('img');image.src=material.image;image.alt=material.name;bead.append(image)}else{const fallback=document.createElement('span');fallback.className='diy-collar__bead-fallback';bead.append(fallback)}canvas.append(bead)}); const remaining=Math.max(3-selected.length,0); empty.hidden=selected.length>0;if(count)count.textContent=selected.length;if(designInput)designInput.value=selected.map((material)=>material.name).join(' · ');if(validation)validation.textContent=remaining?`Add ${remaining} more bead${remaining===1?'':'s'} to complete your collar.`:selected.length >= maximum ? `Maximum of ${maximum} beads reached.` : 'Your collar is ready to add to cart.';if(add)add.disabled=remaining>0; };
    builder.querySelectorAll('[data-collar-base]').forEach((button)=>button.addEventListener('click',()=>{builder.querySelectorAll('[data-collar-base]').forEach((item)=>{item.classList.remove('is-selected');item.setAttribute('aria-pressed','false')});button.classList.add('is-selected');button.setAttribute('aria-pressed','true');base=button;renderBase();render()}));builder.querySelectorAll('[data-material]').forEach((button)=>button.addEventListener('click',()=>{if(selected.length>=maximum)return;selected.push({name:button.dataset.name,image:button.dataset.image,color:button.dataset.color});render()}));builder.querySelectorAll('[data-material-filter]').forEach((filter)=>filter.addEventListener('click',()=>{const category=filter.dataset.materialFilter;builder.querySelectorAll('[data-material-filter]').forEach((item)=>{item.classList.toggle('is-active',item===filter);item.setAttribute('aria-selected',item===filter?'true':'false')});builder.querySelectorAll('[data-material]').forEach((item)=>{item.hidden=item.dataset.category!==category})}));builder.querySelectorAll('[data-material]').forEach((item)=>{item.hidden=item.dataset.category!=='8mm'});builder.querySelector('[data-remove]').addEventListener('click',()=>{selected.pop();render()});builder.querySelector('[data-clear]').addEventListener('click',()=>{selected.length=0;render()});renderBase();render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pyracrystal-journal-index"] && !Shopify.designMode) return;
  try {
    
  const journalSections = document.querySelectorAll('[data-journal-pagination]');

  journalSections.forEach((section) => {
    const cards = Array.from(section.querySelectorAll('.pyra-journal-card'));
    const navigation = section.querySelector('[data-journal-pagination-nav]');
    const pageSize = Number(section.dataset.pageSize) || 9;
    const pageCount = Math.ceil(cards.length / pageSize);

    if (!navigation || pageCount <= 1) return;

    navigation.hidden = false;
    navigation.setAttribute('aria-label', section.dataset.paginationLabel);

    const getRequestedPage = () => {
      const requestedPage = Number(new URL(window.location.href).searchParams.get('page'));
      return Math.min(Math.max(requestedPage || 1, 1), pageCount);
    };

    const showPage = (page, updateUrl) => {
      cards.forEach((card, index) => {
        card.hidden = index < (page - 1) * pageSize || index >= page * pageSize;
      });

      navigation.querySelectorAll('[data-page]').forEach((button) => {
        const buttonPage = Number(button.dataset.page);
        button.toggleAttribute('aria-current', !button.dataset.direction && buttonPage === page);
        if (button.dataset.direction === 'previous') button.disabled = page === 1;
        if (button.dataset.direction === 'next') button.disabled = page === pageCount;
      });

      if (updateUrl) {
        const url = new URL(window.location.href);
        if (page === 1) url.searchParams.delete('page');
        else url.searchParams.set('page', String(page));
        window.history.pushState({}, '', url);
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    const createButton = (label, page, direction) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = label;
      button.dataset.page = String(page);
      if (direction) button.dataset.direction = direction;
      button.setAttribute(
        'aria-label',
        direction ? section.dataset[`${direction}Label`] : section.dataset.pageLabel.replace('__PAGE__', String(page))
      );
      button.addEventListener('click', () => {
        const currentPage = getRequestedPage();
        const destination = direction === 'previous'
          ? Math.max(currentPage - 1, 1)
          : direction === 'next'
            ? Math.min(currentPage + 1, pageCount)
            : page;
        showPage(destination, true);
      });
      navigation.appendChild(button);
    };

    createButton('‹', 1, 'previous');
    for (let page = 1; page <= pageCount; page += 1) createButton(String(page), page);
    createButton('›', pageCount, 'next');
    showPage(getRequestedPage(), false);
    window.addEventListener('popstate', () => showPage(getRequestedPage(), false));
  });

  } catch(e) { console.error(e); }
})();
})();
